import React from 'react'
import Notifications from '../../Pages/Notifications/Notifications.Page';

function NotificationsRoute() {
    return (
        <Notifications />
    );
}

export default NotificationsRoute;
